import blankImage from "../../assets/images/notificationTemplates/blank.jpg"
import productImage from "../../assets/images/notificationTemplates/product.jpg"
import MjmlTemplate from "../../models/mjmlTemplate"

export const mjmlTemplates: MjmlTemplate[] = [
  {
    id: "blank",
    label: "Blank",
    image: blankImage,
    schema: {
      content: {
        type: "page",
        data: {
          value: {
            breakpoint: "480px",
            headAttributes: "",
            "font-size": "15px",
            "line-height": "1.8",
            headStyles: [],
            fonts: [],
            responsive: true,
            "font-family": "'Lato', sans-serif",
            "text-color": "#000000",
            "content-background-color": "#fafafa",
          },
        },
        attributes: {
          "background-color": "#efeeea",
          width: "600px",
        },
        children: [],
      },
    },
  },
  {
    id: "product",
    label: "Product",
    image: productImage,
    validationRules: ["user.first_name", "product.code"],
    notValidLabel: '"First name" or "Code" is missing',
    schema: {
      content: {
        type: "page",
        data: {
          value: {
            breakpoint: "480px",
            headAttributes: "",
            "font-size": "15px",
            "line-height": "1.5",
            headStyles: [],
            fonts: [
              {
                name: "Satoshi",
                href: "https://fonts.cdnfonts.com/css/satoshi",
              },
            ],
            responsive: true,
            "font-family": "'Satoshi', sans-serif",
            "text-color": "#000000",
            "content-background-color": "#fafafa",
          },
        },
        attributes: { "background-color": "#efeeea", width: "600px" },
        children: [
          {
            type: "advanced_spacer",
            data: { value: {} },
            attributes: { height: "20px", padding: "1px 1px 1px 1px" },
            children: [],
          },
          {
            type: "advanced_image",
            data: { value: {} },
            attributes: {
              align: "center",
              height: "auto",
              padding: "0px 0px 0px 0px",
              src: "https://dist.aworld.click/logo/aworld_centred_RGB.png",
              width: "120px",
            },
            children: [],
          },
          {
            type: "advanced_spacer",
            data: { value: {} },
            attributes: { height: "20px", padding: "1px 1px 1px 1px" },
            children: [],
          },
          {
            type: "advanced_image",
            data: { value: {} },
            attributes: {
              align: "center",
              height: "auto",
              padding: "0px 0px 0px 0px",
              src: "https://cdn.aworld.click/product/2025/04/paco-b2b278dd0710.png",
              width: "480px",
            },
            children: [],
          },
          {
            type: "advanced_spacer",
            data: { value: {} },
            attributes: { height: "20px", padding: "1px 1px 1px 1px" },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: {
                content: '<font size="4">Ciao {{user.first_name}},</font>',
              },
            },
            attributes: {
              padding: "10px 25px 10px 25px",
              align: "left",
              "font-family": "",
            },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: { content: "è arrivato il momento di festeggiare 🎉" },
            },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: {
                content:
                  "Hai dimostrato un grande impegno nel rendere il tuo stile di vita più sostenibile e per questo motivo hai ottenuto un premio!",
              },
            },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_text",
            data: { value: { content: "<b>[tipo di premio ricevuto]</b>" } },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_button",
            data: { value: { content: "{{product.code}}" } },
            attributes: {
              align: "center",
              "background-color": "#EDF0F1",
              color: "#000000",
              "font-weight": "bold",
              "border-radius": "4px",
              padding: "10px 25px 10px 25px",
              "inner-padding": "10px 25px 10px 25px",
              "line-height": "120%",
              target: "_blank",
              "vertical-align": "middle",
              border: "none",
              "text-align": "center",
              href: "#",
              width: "220px",
              "font-size": "22px",
            },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: {
                content:
                  "<u><b>Come utilizzare il voucher su [nome partner]</b></u>",
              },
            },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: { content: "[istruzioni su come utilizzare il voucher]" },
            },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: {
                content:
                  "In caso di problemi con il codice univoco, non esitare a contattarci alla mail support@aworld.org",
              },
            },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: {
                content:
                  "<b>Ancora complimenti per il tuo impegno, continua così:</b> nuovi premi ti aspettano!",
              },
            },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_text",
            data: { value: { content: "A presto,<br>Team AWorld 💙" } },
            attributes: { padding: "10px 25px 10px 25px", align: "left" },
            children: [],
          },
          {
            type: "advanced_divider",
            data: { value: {} },
            attributes: {
              align: "center",
              "border-width": "1px",
              "border-style": "solid",
              "border-color": "#C9CCCF",
              padding: "10px 0px 10px 0px",
            },
            children: [],
          },
          {
            type: "advanced_text",
            data: {
              value: {
                content:
                  '<div style="text-align: center;"><span style="font-size: x-small; word-spacing: normal;">This message is automatically generated by our systems, so please do not reply to this email.&nbsp;</span></div><div style="text-align: center;"><font size="1">AWorld Srl Società Benefit · PI: 11867110014.&nbsp;</font></div><div style="text-align: center;"><font size="1">All rights reserved.</font></div>',
              },
            },
            attributes: {
              padding: "10px 25px 10px 25px",
              align: "left",
              "line-height": "1",
            },
            children: [],
          },
        ],
      },
    },
  },
]
